import { Box, CircularProgress, Container, Typography } from '@mui/material'

import { LegalDocumentType, useGetActiveLegalDocumentQuery } from 'generated/graphql'

import { LegalDocumentPreview } from '../settings/LegalDocuments/LegalDocumentPreview'

interface LegalDocumentViewProps {
  documentType: LegalDocumentType
  fallbackTitle: string
}

export const LegalDocumentView = ({ documentType, fallbackTitle }: LegalDocumentViewProps) => {
  const { data, loading, error } = useGetActiveLegalDocumentQuery({
    variables: { documentType },
  })

  if (loading) {
    return (
      <Container sx={{ py: 4, textAlign: 'center' }}>
        <CircularProgress />
      </Container>
    )
  }

  if (error) {
    return (
      <Container sx={{ py: 4 }}>
        <Typography color='error'>Failed to load document: {error.message}</Typography>
      </Container>
    )
  }

  const doc = data?.activeLegalDocument

  if (!doc) {
    return (
      <Container sx={{ py: 4 }}>
        <Typography color='text.secondary'>
          No active {fallbackTitle} document has been published yet.
        </Typography>
      </Container>
    )
  }

  return (
    <Container sx={{ py: 2 }}>
      <Box sx={{ mb: 2 }}>
        <Typography variant='body2' color='text.secondary'>
          Version {doc.versionMajor}.{doc.versionMinor}.{doc.versionPatch}
        </Typography>
      </Box>
      <Box sx={{ lineHeight: 1.8, fontSize: '15px' }}>
        <LegalDocumentPreview content={doc.content} />
      </Box>
    </Container>
  )
}
